export default function filterNotAssignableActivities(activities) {
  return activities.filter(
    (activity) =>
      !(
        activity.type == 'worksheet' ||
        activity.type == 'craft' ||
        activity.type == 'pictureDictionary' ||
        activity.type == 'realTime' ||
        (activity.type == 'shortStory' && activity.data?.subType == 'pdf')
      )
  );
}
